export type VehicleStatus = {
    tipoVeicolo: string | undefined
    targa: string | undefined

    annoImmatricolazione: number | undefined
    meseImmatricolazione: number | undefined
    annoAcquisto: number | undefined

    marca: string | undefined
    modello: string | undefined
    alimentazione: string | undefined
    allestimento: string | undefined
    kw: number | undefined
    marce: number | undefined

    tipoVeicoloError: string | undefined
    targaError: string | undefined

    annoImmatricolazioneError: string | undefined
    meseImmatricolazioneError: string | undefined
    annoAcquistoError: string | undefined

    marcaError: string | undefined
    modelloError: string | undefined
    alimentazioneError: string | undefined
    allestimentoError: string | undefined
    kwError: string | undefined
    marceError: string | undefined

    tipiVeicolo: any
    tipiAlimentazione: any
    tipiMarce: any
    
}

export const baseVehicleInitialStatus = {
    tipoVeicolo: undefined,
    targa: undefined,

    annoImmatricolazione: undefined,
    meseImmatricolazione: undefined,
    annoAcquisto: undefined,

    marca: undefined,
    modello: undefined,
    alimentazione: undefined,
    allestimento: undefined,
    kw: undefined,
    marce: undefined,

    tipoVeicoloError: undefined,
    targaError: undefined,

    annoImmatricolazioneError: undefined,
    annoAcquistoError: undefined,
    meseImmatricolazioneError: undefined,

    marcaError: undefined,
    modelloError: undefined,
    alimentazioneError: undefined,
    allestimentoError: undefined,
    kwError: undefined,
    marceError: undefined,

    tipiVeicolo: undefined,
    tipiAlimentazione: undefined,
    tipiMarce: undefined,
}

export interface VehicleProps extends VehicleStatus {

    updateTipoVeicoloCallBack: Function
    updateTargaCallBack: Function
    updateAnnoImmatricolazioneCallBack: Function
    updateMeseImmatricolazioneCallBack: Function
    updateAnnoAcquistoCallBack: Function
    updateMarcaCallBack: Function
    updateModelloCallBack: Function
    updateAlimentazioneCallBack: Function
    updateAllestimentoCallBack: Function
    updateKwCallBack: Function
    updateMarceCallBack: Function

    regexAnnoImmatricolazione: Function
    regexAnnoAcquisto: Function
    regexMeseAcquisto: Function

}